export default "__VITE_ASSET__82614574__"